import { css } from 'styled-components';

const variables = css`
  :root {
    --dark-navy: #0a192f;
    --navy: #001f3f;
    --light-navy: #0d2a5c;
    --lightest-navy: #1a3a6f;
    --navy-shadow: rgba(0, 31, 63, 0.8);
    --dark-slate: #495670;
    --slate: #6b8bb8;
    --light-slate: #9ba8c4;
    --lightest-slate: #d4d9e8;
    --white: #f0f4f9;
    --green: #0099ff;
    --green-tint: rgba(0, 153, 255, 0.1);
    --pink: #ff6b9d;
    --blue: #0099ff;

    --font-sans: 'Calibre', 'Inter', 'San Francisco', 'SF Pro Text', -apple-system, system-ui,
      sans-serif;
    --font-mono: 'SF Mono', 'Fira Code', 'Fira Mono', 'Roboto Mono', monospace;

    --fz-xxs: 10px; /* Reduced for smaller screens */
    --fz-xs: 11px; /* Reduced for smaller screens */
    --fz-sm: 12px; /* Reduced for smaller screens */
    --fz-md: 14px; /* Reduced for smaller screens */
    --fz-lg: 16px; /* Reduced for smaller screens */
    --fz-xl: 18px; /* Reduced for smaller screens */
    --fz-xxl: 20px; /* Reduced for smaller screens */
    --fz-heading: 28px; /* Reduced for smaller screens */

    --border-radius: 4px;
    --nav-height: 100px;
    --nav-scroll-height: 70px;

    --tab-height: 42px;
    --tab-width: 120px;

    --easing: cubic-bezier(0.645, 0.045, 0.355, 1);
    --transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);

    --hamburger-width: 30px;

    --ham-before: top 0.1s ease-in 0.25s, opacity 0.1s ease-in;
    --ham-before-active: top 0.1s ease-out, opacity 0.1s ease-out 0.12s;
    --ham-after: bottom 0.1s ease-in 0.25s, transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);
    --ham-after-active: bottom 0.1s ease-out,
      transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;
  }
`;

export default variables;
